import styled, { css } from 'styled-components';
import { palette, key } from 'styled-theme';

import { media } from '../../../helper/styleHelper';

const fontSettings = {
  normal: {
    size: key('sizes.font.normal', '11px'),
    spacing: '0.3px',
  },
};

const xlFontSettings = {
  normal: {
    size: key('sizes.xlFont.normal', '14px'),
    spacing: '0.3px',
  },
};

const xlrFontSettings = {
  normal: {
    size: key('sizes.xlrFont.normal', '14px'),
    spacing: '0.3px',
  },
};

const xxlFontSettings = {
  normal: {
    size: key('sizes.xxlFont.normal', '16px'),
    spacing: '0.3px',
  },
};

const sizes = {
  normal: {
    width: key('sizes.button.normal.width', '175px'),
    height: key('sizes.button.normal.height', '30px'),
    borderBottom: '0px',
  },
};

const xlSizes = {
  normal: {
    width: key('sizes.button.normal.width', '150px'),
    height: key('sizes.button.normal.height', '30px'),
    borderBottom: '0px',
  },
};

const xlrSizes = {
  normal: {
    width: key('sizes.button.normal.width', '150px'),
    height: key('sizes.button.normal.height', '30px'),
    borderBottom: '0px',
  },
};

const xxlSizes = {
  normal: {
    width: key('sizes.button.normal.width', '150px'),
    height: key('sizes.button.normal.height', '30px'),
    borderBottom: '0px',
  },
};

const colorGroups = {
  primary: {
    main: palette('primary', 0),
    darken: palette('primary', 1),
    lighten: '#E9F5FA',
    text: palette('primary', 0),
    borderBottom: palette('primary', 0),
    background: palette('background', 0),
  },
  success: {
    main: palette('success', 0),
    darken: palette('success', 1),
    lighten: palette('success', 2),
    text: palette('success', 0),
    borderBottom: palette('success', 3),
    background: palette('background', 0),
  },
  warning: {
    main: palette('warning', 0),
    darken: palette('warning', 1),
    lighten: palette('warning', 2),
    text: palette('warning', 0),
    borderBottom: palette('warning', 3),
    background: palette('background', 0),
  },
  error: {
    main: palette('error', 0),
    darken: palette('error', 1),
    lighten: palette('error', 2),
    text: palette('error', 0),
    borderBottom: palette('error', 3),
    background: palette('background', 0),
  },
  secondary: {
    main: palette('gray', 0),
    darken: palette('gray', 1),
    lighten: palette('gray', 2),
    text: palette('gray', 0),
    borderBottom: palette('gray', 0),
    background: palette('background', 0),
  },
};

const getThemes = () => {
  const theme = {};

  Object.keys(colorGroups).forEach((colorType) => {
    const value = {};
    const { main, darken, text, borderBottom, lighten } = colorGroups[colorType];

    value.default = {
      text: palette('primary', 3),
      border: text,
      background: main,
      action: {
        text: palette('text', 1),
        border: darken,
        background: darken,
      },
      focus: {
        border: darken,
      },
    };

    value.outline = {
      text: palette('text', 1),
      border: palette('gray', 0),
      background: palette('background', 1),
      action: {
        text: main,
        border: main,
        background: lighten,
      },
      focus: {
        border: main,
      },
    };

    value.normal = {
      text: palette('text', 0),
      border: palette('border', 0),
      background: palette('background', 2),
      action: {
        text: palette('text', 1),
        border: '#fff',
        background: palette('background', 1),
      },
      focus: {
        border: palette('gray', 0),
        borderBottom,
      },
    };

    theme[colorType] = value;
  });

  return theme;
};

const themes = getThemes();

const getThemeValue = (color, typeValue) => {
  const theme = themes[color];
  const themValue = theme && theme[typeValue];
  return themValue;
};

export const StyledButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  border-width: 0.5px;
  transition: opacity 0.3s;

  ${(props) => css`
    border-radius: ${props.round === 'true' ? sizes[props.sizevalue].height : '5px'};

    min-width: ${props.buttonMinWidth ? props.buttonMinWidth : sizes[props.sizevalue].width};
    height: ${sizes[props.sizevalue].height};
    font-size: ${fontSettings[props.sizevalue].size};
    font-weight: ${props.weight};
    letter-spacing: ${fontSettings[props.sizevalue].spacing};
  `}

  ${(props) => media.xl`
border-radius: ${props.round === 'true' ? xlSizes[props.sizevalue].height : '5px'};
height: ${xlSizes[props.sizevalue].height};
font-size: ${xlFontSettings[props.sizevalue].size};
letter-spacing: ${xlFontSettings[props.sizevalue].spacing};
`}

${(props) => media.xlr`
border-radius: ${props.round === 'true' ? xlrSizes[props.sizevalue].height : '10px'};
height: ${xlrSizes[props.sizevalue].height};
font-size: ${xlrFontSettings[props.sizevalue].size};
letter-spacing: ${xlrFontSettings[props.sizevalue].spacing};
`}

  ${(props) => media.xxl`
border-radius: ${props.round === 'true' ? xxlSizes[props.sizevalue].height : '10px'};
height: ${xxlSizes[props.sizevalue].height};
font-size: ${xxlFontSettings[props.sizevalue].size};
letter-spacing: ${xxlFontSettings[props.sizevalue].spacing};
`}
  /* width: 100%; */

  font-family: ${key('fonts.primary', 'Space Grotesk Regular')};
  border-style: solid;

  &,
  &:active,
  &:focus {
    color: ${(props) => getThemeValue(props.color, props.varient)?.text ?? ''};
    border-color: ${(props) => getThemeValue(props.color, props.varient)?.border ?? ''};
    background: ${(props) => getThemeValue(props.color, props.varient)?.background ?? ''};
    ${(props) =>
      props.varient === 'normal' &&
      `background-position: 0 100%;
       background-repeat: no-repeat;
       -webkit-background-size: 100% 3px;
       -moz-background-size: 100% 3px;
        background-size: 100% 3px;
        `}
  }
  &:focus,
  &:active {
    border-color: ${(props) =>
      getThemeValue(props.color, props.varient)?.focus.border ?? ''} !important;
  }

  &.focused,
  &:hover {
    &,
    &:focus,
    &:active {
      color: ${(props) => getThemeValue(props.color, props.varient)?.action.text ?? ''};
      border-color: ${(props) => getThemeValue(props.color, props.varient)?.action.border ?? ''};
      cursor: pointer;
      background: ${(props) => getThemeValue(props.color, props.varient)?.action.background ?? ''};
      ${(props) =>
        props.varient === 'normal' &&
        `
          background-position: 0 100%;
          background-repeat: no-repeat;
          -webkit-background-size: 100% 3px;
          -moz-background-size: 100% 3px;
          background-size: 100% 3px;
        `}
    }
  }

  img,
  svg {
    margin-right: 10px;
  }
  ${media.xxl`
 font-size:${key('sizes.xxlFont.big', '20px')};
  img{
    width: 15px;
    height: 15px;
  }
  `}
  ${(props) =>
    props.flat === 'true'
      ? css`
          border-radius: 0px !important;
        `
      : null}

      /* ${({ disabled }) =>
    disabled ? 'background: #A5CDF5 !important; border: none !important;' : ''} */

    ${({ disabled }) =>
    disabled
      ? css`
          opacity: 0.5;
          cursor: not-allowed !important;
          background-color: #d1d5db !important;
          border: none !important;
        `
      : css``}
`;
